import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/vanilla/utils';
import {
  ActualityAggregatedStatsViewMode,
  ActualityAggregationChartTooltipMode,
  ActualityAggregationColorBy,
} from './actuality.kpi.types';

const getKey = (postfix: string) =>
  `warebee-actuality-aggregated-stats-ui-${postfix}`;

export const actualityAggregatedStatsDataPageSelected = atom<number>(1);

export const actualityAggregatedStatsViewModeSelected =
  atomWithStorage<ActualityAggregatedStatsViewMode>(
    getKey('view-mode'),
    'compare',
  );

export const actualityAggregatedStatsColorBySelected =
  atomWithStorage<ActualityAggregationColorBy>(getKey('color-by'), 'bucket');

export const actualityAggregatedStatsTooltipModeSelected =
  atomWithStorage<ActualityAggregationChartTooltipMode>(
    getKey('tooltip-mode'),
    'current',
  );

export const actualityAggregatedStatsAllSelectedWhenEmpty =
  atom<boolean>(false);
